<template>
  <div
    :class="`content-section ${classes} ${no_margin ? '' : 'content-panel'}`"
    compact
  >
    <div class="content-section__header">
      <vb-icon v-if="icon" :name="icon" :size="20"></vb-icon>
      <span class="content-section__title" v-html="title"></span>
    </div>
    <p
      v-if="description"
      class="content-section__description"
      v-html="description"
    ></p>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "content-section",
  props: {
    icon: String,
    title: String,
    description: String,
    classes: String,
    no_margin: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.content-section {
  margin-bottom: 1rem !important;
  display: flex;
  flex-direction: column;
  gap: 10px;

  &__header {
    display: flex;
    gap: 10px;
    align-items: center;
  }
  &__title {
    font-weight: $vb-font-weight-semibold;
  }
}
</style>
